let selectedPlanIndex = document.querySelector('.cart-box.active')?.getAttribute('data-key');
export default {cartState: {...cartParams, selected_package_index: selectedPlanIndex || 0}} || {};
